import React, { useState } from "react";

export default function ShowMore({ text, limit = 30 }) {
  const [show, setShow] = useState(false);
  const wordCount = text.split(" ").length;
  return (
    <div>
      {wordCount > limit ? (
        <>
          {show ? text : text.split(" ").slice(0, limit).join(" ") + "..."}
          <div className="d-flex justify-content-end">
            <button
              type="button"
              onClick={() => setShow(!show)}
              className="btn btn-link p-0 mt-2"
            >
              {show ? "Show Less" : "Show More"}
            </button>
          </div>
        </>
      ) : (
        <span>{text}</span>
      )}
    </div>
  );
}
